(function(){
  'use strict';

  if(window.__vivieroBookPaletteGalleryV2)return;
  window.__vivieroBookPaletteGalleryV2=true;

  function getLibrary(){
    return document.querySelector('[id^="vbp-palette-library-"]');
  }

  function getProductSection(){
    return document.querySelector('section.product__container[data-product-wrapper], section.product__container');
  }

  function ensureControls(library){
    if(!library || library.querySelector('[data-vpg-controls]'))return;

    var grid=library.querySelector('.vbp-pal-grid');
    if(!grid)return;

    library.classList.add('vpg-fullwidth-gallery');

    var controls=document.createElement('div');
    controls.className='vpg-controls';
    controls.setAttribute('data-vpg-controls','true');

    var nav=document.createElement('div');
    nav.className='vpg-nav';

    var prev=document.createElement('button');
    prev.type='button';
    prev.className='vpg-arrow';
    prev.setAttribute('aria-label','Previous palettes');
    prev.innerHTML='&#8249;';

    var next=document.createElement('button');
    next.type='button';
    next.className='vpg-arrow';
    next.setAttribute('aria-label','Next palettes');
    next.innerHTML='&#8250;';

    var viewAll=document.createElement('button');
    viewAll.type='button';
    viewAll.className='vpg-view-all';
    viewAll.textContent='View all palettes';

    nav.appendChild(prev);
    nav.appendChild(next);
    controls.appendChild(viewAll);
    controls.appendChild(nav);

    grid.parentNode.insertBefore(controls,grid);

    function amount(){
      return Math.max(260,Math.round(grid.clientWidth*0.82));
    }

    prev.addEventListener('click',function(){
      grid.scrollBy({left:-amount(),behavior:'smooth'});
    });

    next.addEventListener('click',function(){
      grid.scrollBy({left:amount(),behavior:'smooth'});
    });

    viewAll.addEventListener('click',function(){
      var expanded=library.classList.toggle('vpg-expanded');
      viewAll.textContent=expanded?'Show carousel':'View all palettes';
      if(!expanded){
        window.setTimeout(function(){grid.scrollTo({left:0,behavior:'smooth'});},40);
      }
    });
  }

  function placeLibrary(){
    var library=getLibrary();
    var section=getProductSection();
    if(!library || !section)return false;

    ensureControls(library);

    if(section.nextElementSibling!==library){
      section.insertAdjacentElement('afterend',library);
    }

    library.classList.add('vpg-fullwidth-gallery');
    return true;
  }

  var scheduled=false;
  function schedule(){
    if(scheduled)return;
    scheduled=true;
    window.requestAnimationFrame(function(){
      scheduled=false;
      placeLibrary();
    });
  }

  function start(){
    schedule();
    [100,350,800,1400,2200,3200,4500].forEach(function(delay){
      window.setTimeout(schedule,delay);
    });

    var observer=new MutationObserver(function(){
      var library=getLibrary();
      var section=getProductSection();
      if(library && section && section.nextElementSibling!==library){
        schedule();
      }
    });

    observer.observe(document.body,{childList:true,subtree:true});
    window.addEventListener('resize',schedule);
    document.addEventListener('shopify:section:load',schedule);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',start,{once:true});
  }else{
    start();
  }
})();